import TrashpinIcon from './component'

export default TrashpinIcon
